import axios from 'axios';

const BASE_URL = import.meta.env?.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const userService = {
  // Login User: POST .../api/users/login
 login: async (userData) => { 
  try {
    // Pass 'userData' (which contains email, password, and role) as the body
    const response = await axios.post(`${BASE_URL}/users/login`, userData);
    return response.data; 
  } catch (error) {
    // Improved error handling to capture backend messages
    throw error.response?.data || "Login failed";
  }
},

  // Create User: POST .../api/users/create
  createUser: async (userData) => {
    // userData format: { name, email, password, role, phoneNumber }
    try {
      const response = await axios.post(`${BASE_URL}/users/create`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || "User creation failed";
    }
  },

  // List Users: POST .../api/users/list
  listUsers: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/users/list`, {});
      return response.data;
    } catch (error) {
      throw error.response?.data || "Failed to fetch users";
    }
  },

  // Update User: POST .../api/users/update
  updateUser: async (userData) => {
    try {
      // Your backend expects { id: '...', name: '...' }
      const payload = { id: userData._id, ...userData };
      const response = await axios.post(`${BASE_URL}/users/update`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || "User update failed";
    }
  },

  // Delete User: POST .../api/users/delete
  deleteUser: async (userId) => {
    try {
      const response = await axios.post(`${BASE_URL}/users/delete`, { id: userId });
      return response.data;
    } catch (error) {
      throw error.response?.data || "User deletion failed";
    }
  }
};

export default userService;